import { Dash } from '@mews-commander/ui';
import { DccPaymentDetail } from '@mews-commander/data-access';
import { NumberService } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { useCultureCode } from '@mews-commander/core';
import { getCurrencyCultureInfo } from '@mews-commander/core/legacy-globalization';
import { useCommanderSelector } from '@mews-commander/utils';

export const DccPaymentDetailsExchangeRateEntry = ({
    fromCurrency,
    toCurrency,
}: {
    fromCurrency: DccPaymentDetail['fromCurrency'];
    toCurrency: DccPaymentDetail['toCurrency'];
}) => {
    const cultureCode = useCultureCode();
    const currencyCultureInfo = useCommanderSelector((state) => getCurrencyCultureInfo(state, { cultureCode }));

    if (!fromCurrency || !toCurrency) {
        return <Dash />;
    }

    const toCurrencyNumber = NumberService.formatCurrencyValue(toCurrency.value, currencyCultureInfo, {
        precision: 2,
        showSymbol: false,
    });

    const fromCurrencyNumber = NumberService.formatCurrencyValue(fromCurrency.value, currencyCultureInfo, {
        precision: 0,
        showSymbol: false,
    });

    const toCurrencyStr = `${toCurrencyNumber}${UnicodeEntity.NoBreakSpace}${toCurrency.currencyCode}`;
    const fromCurrencyStr = `${fromCurrencyNumber}${UnicodeEntity.NoBreakSpace}${fromCurrency.currencyCode}`;

    return (
        <>{`${fromCurrencyStr}${UnicodeEntity.NoBreakSpace}${UnicodeEntity.Equals}${UnicodeEntity.NoBreakSpace}${toCurrencyStr}`}</>
    );
};
